const state = {
  savings : [],
  errors: null
}

export default state